// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --headerHeight: 4rem;
  --headerHeightMobile: calc(var(--headerHeight) * .8);
}

:root {
  --sidenavWidth: 25.25rem;
}

.side-nav-container .side-nav {
    position: fixed;
    top: 0;
    z-index: 96;
    width: 100%;
    height: 100vh;
    overflow: auto;
    color: #fff;
    background-color: #fff;
  }

@media (width > 640px) {

.side-nav-container .side-nav {
      width: 25.25rem
  }
    }

.side-nav-container .side-nav--left {
      left: 0;
      transform: translateX(-100%);
    }

.side-nav-container .side-nav--right {
      right: 0;
      transform: translateX(100%);
    }

.side-nav-container .side-nav__header {
      display: inline-block;
      padding: 1rem 0;
      font-weight: 700;
      color: #424242;
      -webkit-text-decoration: none;
      text-decoration: none;
      cursor: pointer;
      border-bottom: calc(.25rem) solid #fff;
      display: flex;
      padding: 1rem;
      font-weight: 400;
      cursor: default;
      border-bottom: 0.0625rem solid #d4d4d4;
    }

.side-nav-container .side-nav__header__title {
        flex: 1 1 auto;
        font-weight: 700;
      }

.side-nav-container .side-nav__header__close {
        flex: 0 0 24px;
        color: #707070;
        cursor: pointer;
      }

.side-nav-container .side-nav__header__close:hover {
          color: #424242;
        }

.side-nav-container .overlay__grey {
    opacity: 0;
  }

.side-nav-container .side-nav-items {
    padding: 0;
    margin: 0;
    list-style-type: none;
  }

.side-nav-container .side-nav-header__item {
    font-weight: 400;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
